exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".scrolling-list{width:100%;height:100%;font-size:1.72vw;font-weight:700;position:relative;background-color:#347fa2;padding:1.4vh 1.56vw;border:none}.scrolling-list:focus,.scrolling-list:hover{background-color:#007cb4;border:none}.scrolling-list .left-arrow{width:5%;float:left;text-align:left}.scrolling-list .itemText{width:90%;float:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis!important;color:#f1f1f1;font-family:Open Sans Bold}.scrolling-list .right-arrow{width:5%;float:left;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/scrollingList/scrollingList.scss
// module id = 59
// module chunks = 0